/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop.js';
import styled from 'styled-components';
import { mediaQuery } from '@gcc/pip-components/dist/Desktop';
import QuickLinksWithDownloadMessage from '@gcc/pip-components/dist/templates/ProductOverview/QuickLinksWithDownloadMessage';
import { Grid, GridItem } from '@gcc/pip-components/dist/grids';
import CoreOverview from './core';

// hide RichContent on mobile
const ThdCoreOverview = styled(CoreOverview)`
  ${mediaQuery}
`;

const ProductOverview = (props) => (
  <div id="product-overview-component" className={props.className}>
    <Grid id="product_description" className="product-overview section" data-section="product-overview">
      <GridItem>
        <div className="row-header">
          <div className="row-header__title">
            <h2 className="sui-h2-bold sui-line-clamp-unset sui-text-primary">Product Overview</h2>
          </div>
        </div>

        <div className="pipfigurator-row">
          <ThdCoreOverview {...props} />

          <GridItem id="moreinfo_wrapper" md={5} xs={12} data-component="info-and-guides">
            <QuickLinksWithDownloadMessage markdown={props.quickLinks} onListLinkAnalyticsTrack={props.onListLinkAnalyticsTrack} />
          </GridItem>
        </div>
      </GridItem>
    </Grid>
  </div>
);

ProductOverview.propTypes = {
  className: PropTypes.string.isRequired,
  modelNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  partnerProductId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  productDescription: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  storeSku: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  quickLinks: PropTypes.string.isRequired,
  richContent: PropTypes.string.isRequired,
  onListLinkAnalyticsTrack: PropTypes.func,
  isCt: PropTypes.bool,
};

ProductOverview.defaultProps = {
  onListLinkAnalyticsTrack: noop,
  isCt: false,
};

export default ProductOverview;
